module.exports = __webpack_public_path__ + "static/media/flatbread-product-5.b6916f8a.svg";